






































































import Vue from 'vue';
import Component from 'vue-class-component';
import { FormData } from '@/repositories/apiClients.generated';
import { FeedbackApiClient } from '@/repositories';

@Component
export default class SupportForm extends Vue {
    loading = false;
    submitting = false;
    valid = false;
    feedbackStatus = 0;

    formData = new FormData({
        metadata: this.$route.query,
        name: '',
        email: '',
        phoneNumber: '',
        comments: ''
    });

    nameRules = [(v: string) => !v || v.length <= 100 || 'Name must be less than 100 characters'];
    emailRules = [
        (v: string) => !!v?.trim() || 'E-mail is required',
        (v: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v?.trim()) || 'E-mail must be valid',
        (v: string) => !v || v.length <= 100 || 'Email must be less than 100 characters'
    ];
    phoneRules = [
        (v: string) => !v || v.length <= 31 || 'Phone must be less than 31 characters',
        (v: string) => !v || /^[+]?[0-9 ()]{1,31}$/.test(v) || 'Phone number must only contain numbers, spaces or +'
    ];
    commentsRule = [(v: string) => !!v?.trim() || 'A message is required', (v: string) => !v || v.length <= 5000 || 'Message must be less than 5000 characters'];

    created(): void {
        this.$vuetify.theme.dark = false;
    }

    get isFormValid(): boolean {
        const fields: [string | undefined, Array<(v: string) => true | string>][] = [
            [this.formData.name, this.nameRules],
            [this.formData.email, this.emailRules],
            [this.formData.phoneNumber, this.phoneRules],
            [this.formData.comments, this.commentsRule]
        ];
        return fields.every(([value, rules]) => rules.every(rule => rule(value ?? '') === true));
    }

    async submitForm() {
        if (!(this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            return;
        }
        try {
            this.submitting = true;
            this.formData.name = this.formData.name?.trim();
            this.formData.email = this.formData.email?.trim();
            this.formData.phoneNumber = this.formData.phoneNumber?.trim();
            this.formData.comments = this.formData.comments?.trim();
            var apiClient = new FeedbackApiClient();
            const response = await apiClient.post(this.formData);
            this.feedbackStatus = response.status;
        } catch (error: any) {
            this.feedbackStatus = error?.response?.status || 500;
        } finally {
            this.submitting = false;
        }
    }
}
